import { useEffect, useState } from "react";
import FormField from "./FormField";
import Text from "./Text";
import Container from "./Container";
import { InputText } from "primereact/inputtext";
import Icon from "./Icon";
import { ProgressSpinner } from "primereact/progressspinner";
import useAuthHttp from "../hooks/useAuthHttp";
import { useQuery } from "@tanstack/react-query";

export interface IStock {
    ticker_symbol: string;
    company_short_name: string;
}

interface IStockList {
    stock_list: IStock[];
}

export interface IStockSearchSelectorProps {
    selected: IStock|undefined;
    select: (currency: IStock|undefined) => void;
    hasError?: boolean;
    error?: string;
}

const StockSearchSelector = (props: IStockSearchSelectorProps) => {
    const [searchQueryDebounce, setSearchQueryDebounce] = useState<string>("");
    const [searchQuery, setSearchQuery] = useState<string>("");

    const authHttp = useAuthHttp();
    const stockQuery = useQuery({
        queryKey: ["stock", searchQueryDebounce],
        queryFn: async () => {
            if (!searchQueryDebounce) {
                return { stock_list: [] };
            }
            
            return await authHttp.doGet<IStockList>("/stock?search=" + searchQueryDebounce);
        }
    });
    useEffect(() => {
        const timeout = setTimeout(async () => {
            setSearchQueryDebounce(searchQuery);
        }, 1500);

        return () => clearTimeout(timeout);
    }, [searchQuery]);

    return (
        <FormField
            id="stockSearchSelector"
            label="Ações"
            hasError={props.hasError}
            error={props.error}
        >
            <Container relative>
                <InputText 
                    value={props.selected?.ticker_symbol ?? searchQuery}
                    className="w-full pr-5"
                    placeholder="Procure pela ação"
                    invalid={props.hasError}
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                    }}
                />
                
                {
                    props.selected && <Icon 
                        name="pi-times"
                        className="absolute right-0 mr-1 p-2 text-red-500 bg-white"
                        onClick={() => {
                            props.select(undefined);
                            setSearchQuery("");
                        }}
                        style={{ transform: "translateY(-50%)", top: "50%" }}
                    />
                }
            </Container>
            {
                stockQuery.isPending && (
                    <Container center flexColumn className="my-progress-spinner p-4" gap={2}>
                        <ProgressSpinner className="w-2rem h-auto" />
                        <Text>Carregando...</Text>
                    </Container>       
                )
            }

            {
                !!stockQuery.data?.stock_list?.length && !props.selected && !stockQuery.isPending && searchQuery && <div className="bg-white w-full">
                    <ul className="list-none p-0 flex gap-2 flex-column">
                        {
                            stockQuery.data.stock_list?.map(stock => {
                                return (
                                    <li key={stock.ticker_symbol}>
                                        <a 
                                            className="cursor-pointer" 
                                            onClick={() => {
                                                props.select(stock);
                                                setSearchQuery("");
                                            }}
                                        >
                                            {stock.ticker_symbol}
                                        </a>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }
        </FormField>
    );
}

export default StockSearchSelector;